export default {
  inject: ['load'],
  data() {
    return {
      allHeartSoundsForOther: [],
      heartSound: null,
    };
  },
  methods: {
    getListOfHeartSoundsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllHeartSounds').then(() => {
        if (this.$store.state.heartSoundModule.successFlag) {
          this.allHeartSoundsForOther = this.$store.state.heartSoundModule.allHeartSounds;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.heartSoundModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfHeartSoundsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getHeartSoundFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getHeartSound', id).then(() => {
        if (this.$store.state.heartSoundModule.successFlag) {
          this.heartSound = this.$store.state.heartSoundModule.heartSound;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.heartSoundModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getHeartSoundFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.heartSoundModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
